const dataSet = {
  background: "/landscape.jpg",
  services: [
    {
      id: "น้ำตกธรรมชาติ",
      header: "น้ำตกธรรมชาติ",
      description:
        "Natural\nWaterfalls",
      image: "/Services/waterfall.webp",
      video: "/videoplayback.mp4",
      changeDate: "2024-11-15T08:30:00Z",
      pin: true,
      additionalInfo: [
        "ออกแบบสวนเฉพาะคุณ",
        "มีบริการดูแลหลังติดตั้ง",
        "ปรับปรุงคุณภาพดิน",
        "ตกแต่งหิน น้ำ และองค์ประกอบสวน",
      ]
    },
    {
      id: "ลำธารน้ำไหล",
      header: "ลำธารน้ำไหล",
      description:
        "Flowing\nStreams",
      image: "/Services/stream-crop.webp",
      video: "/videoplayback.mp4",
      changeDate: "2024-11-15T05:30:00Z",
      pin: true,
      additionalInfo: [
        "ออกแบบสวนในเมือง",
        "พื้นที่ใช้งานสำหรับชุมชน",
        "ออกแบบอย่างยั่งยืน",
        "รับงานขนาดใหญ่",
      ]
    },
    {
      id: "บ่อระบบนิเวศ",
      header: "บ่อระบบนิเวศ",
      description:
        "Ecosystem\nPonds",
      image: "/Services/ecopond.webp",
      video: "/videoplayback.mp4",
      changeDate: "2024-11-15T06:30:00Z",
      pin: true,
      additionalInfo: [
        "พื้นทางเดินตกแต่งสวยงาม",
        "กำแพงกันดินหรือแนวโครงสร้าง",
        "ระบบน้ำตก/บ่อปลาเสริมพื้นที่",
        "องค์ประกอบหินและคอนกรีต",
      ]
    },
    {
      id: "สระว่ายน้ำธรรมชาติ",
      header: "สระว่ายน้ำธรรมชาติ",
      description:
        "Swimming\nPonds",
      image: "/Services/swim-pond.webp",
      video: "/videoplayback.mp4",
      changeDate: "2024-11-15T06:30:00Z",
      pin: true,
      additionalInfo: [
        "พื้นทางเดินตกแต่งสวยงาม",
        "กำแพงกันดินหรือแนวโครงสร้าง",
        "ระบบน้ำตก/บ่อปลาเสริมพื้นที่",
        "องค์ประกอบหินและคอนกรีต",
      ]
    },
  ],
};

export default dataSet;
